module.exports = __webpack_public_path__ + "img/objetos-11.d0d80254.png";